// Feed brand names by region and CZ variant.
// Mirrors the shortName switch in generate-sitemap.js — update both when adding feeds.

export const CZ_VARIANT_FEED_NAMES: Readonly<Record<string, string>> = {
  v1: 'Goodfin',
  'v1-2': 'Goodfin',
  v3: 'Goodfin',
  v2: 'Pujckafon',
};

export const REGION_FEED_NAMES: Readonly<Record<string, string>> = {
  za: 'Twalalend',
  za_2: 'Yebofin',
  kz: 'Finero KZ',
  kz_kz: 'Finero KZ',
};

export const DEFAULT_FEED_NAME = 'Finero';
